import { useEffect, useState } from "react";
import { http } from "./api";

const DEFAULTS = {
  company_name: "Koshsam Taxi",
  brand_name: "Sam Taxi",
  phone: "+31687170128",
  whatsapp: "+31648261160",
  email: "KoshSam.nl@gmail.com",
  address: "Amsterdam, Netherlands",
};

let _cache = null;

export function useCompanySettings() {
  const [s, setS] = useState(_cache || DEFAULTS);
  useEffect(() => {
    if (_cache) return;
    http.get("/settings").then(({ data }) => {
      _cache = { ...DEFAULTS, ...data };
      setS(_cache);
    }).catch(() => {});
  }, []);
  return s;
}
